/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const CmpButtonCoach = ({ property1, className, divClassName, text = "Continue" }) => {
  return (
    <button className={`cmp-button-coach ${className}`}>
      <div className={`text-wrapper ${divClassName}`}>{text}</div>
    </button>
  );
};

CmpButtonCoach.propTypes = {
  property1: PropTypes.oneOf(["default"]),
  text: PropTypes.string,
};
